// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"253e22fe","412":"eac7a341"}[chunkId] + ".chunk.css";
};